export default __webpack_public_path__ + "static/media/trr-food-smallplate-waffle.9f9e86a0.png";